import React, { useEffect, useRef } from 'react'
import 'trix'
import 'trix/dist/trix.css'
import { useField } from 'formik'
import FormHelperText from '@material-ui/core/FormHelperText'

const TrixEditor = (props) => {
  const trixEditor = useRef(null)
  const { index, name, value, onChange } = props
  const [field, meta] = useField(name)

  const helperText = !!meta.error ? meta.error : null

  useEffect(() => {
    const element = trixEditor.current

    element.addEventListener('trix-change', (e) => {
      onChange(name, trixEditor.current.value)
    })
    return () => {
      element.removeEventListener('trix-change', () => {})
    }
  }, [trixEditor, onChange, name])

  return (
    <div>
      <input type="hidden" id={`trix-${index}`} name={field.name} value={value} />
      <div id="blank-toolbar" hidden />
      <trix-editor
        toolbar="blank-toolbar"
        input={`trix-${index}`}
        ref={trixEditor}
        placeholder="Please list out your accomplishments in bullets. For example: '-Classified and reconciled over 10,000 transactions a month for mid-sized technology company.'. Or '- Handled ERP implementations for 3 clients moving from Quickbooks to Netsuite.'"
      />
      <FormHelperText error>{helperText}</FormHelperText>
    </div>
  )
}

export default TrixEditor
